var _path, _path2, _path3, _g, _g2, _g3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateprofile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.031,
    cy: 29.658,
    r: 20.243,
    fill: "#e30613",
    strokeOpacity: 0.55949,
    strokeWidth: 9.2798,
    style: {
      paintOrder: "fill markers stroke"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.15,0,0,1.15,-4.1064,-2.005)",
    d: "m16.687 6.2801c-0.9659 4.7937-4.4812 22.817-5.416 27.627-0.0613 0.3155 0.0045 0.6424 0.1831 0.9095 0.1786 0.2672 0.4555 0.453 0.7704 0.517l19.731 3.9983c0.1576 0.0318 0.32 0.0322 0.4777 1e-3 0.1578-0.0312 0.3078-0.0933 0.4415-0.1828 0.1336-0.0894 0.2483-0.2044 0.3372-0.3384 0.089-0.1339 0.1506-0.2842 0.1813-0.442l2.7011-13.935 1.6842 0.2601c0.1987 0.0306 0.4014-0.0172 0.5654-0.1334 0.164-0.1161 0.2764-0.2915 0.3135-0.489l2.0538-11.254c0.0184-0.1 0.0168-0.2026-0.0046-0.3019-0.0214-0.0994-0.0621-0.1936-0.1199-0.2772s-0.1316-0.1549-0.217-0.21-0.1808-0.0928-0.2809-0.1109l-1.5124-0.2838 0.198-1.0879c0.0569-0.3138-0.0123-0.63731-0.1924-0.90041-0.1801-0.26311-0.4568-0.44456-0.7698-0.50498l-19.712-3.8103c-0.313-0.05905-0.6367 0.00749-0.9011 0.18522s-0.4482 0.45237-0.5117 0.76455z",
    fill: "#a1a1a1",
    filter: "url(#filter0_d_38_559)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.15,0,0,1.15,-4.1064,-2.005)",
    d: "m18.154 6.7429-6.5151 27.571 20.243 4.6393 6.3794-27.376z",
    fill: "#e1e1e1",
    filter: "url(#filter0_d_38_559)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.15,0,0,1.15,-4.1064,-2.005)",
    d: "m31.568 36.783-20.264-3.2233 4.5982-27.699 20.142 3.4236z",
    fill: "#ebebeb",
    filter: "url(#filter0_d_38_559)",
    stroke: "#a1a1a1",
    strokeWidth: 0.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.15,0,0,1.15,-4.1064,-2.005)",
    filter: "url(#filter1_d_38_559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.791 7.1789-0.8651 28.316 20.762 0.4954 0.7717-28.1z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.808 6.6792-0.5017-0.01728-0.0153 0.50172-0.8651 28.316-0.0154 0.5032 0.5032 0.012 20.762 0.4954 0.498 0.0119 0.0137-0.498 0.7718-28.1 0.0136-0.49633-0.4962-0.0171z",
    stroke: "#a1a1a1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.15,0,0,1.15,-4.1064,-2.005)",
    fill: "#575756"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.744 13.238c0 0.0547-1.7917 0.0485-4.0004-0.0112-2.2086-0.0598-3.9996-0.1519-3.9996-0.2054 0-0.0536 1.7916-0.0486 4.0009 0.0112 2.2093 0.0597 3.9997 0.1518 3.9991 0.2054z",
    filter: "url(#filter0_d_38_559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.746 15.744c0 0.0535-1.7911 0.0486-4.0006-0.0112-2.2095-0.0597-4-0.1531-3.9994-0.2066 6e-4 -0.0536 1.7912-0.0486 4.0006 0.0112 2.2095 0.0597 4 0.1531 3.9994 0.2066z",
    filter: "url(#filter0_d_38_559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.911 23.423c0 0.0536-3.5725 0.0486-7.9766-0.0112-4.404-0.0597-7.9765-0.1518-7.9753-0.2066 0.0013-0.0548 3.5713-0.0486 7.9778 0.0124s7.9741 0.1519 7.9741 0.2054z",
    filter: "url(#filter0_d_38_559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.911 20.989c0 0.0536-3.5725 0.0486-7.9766-0.0124-4.404-0.061-7.9765-0.1519-7.9753-0.2054 0.0013-0.0535 3.5713-0.0485 7.9778 0.0112s7.9741 0.1581 7.9741 0.2066z",
    filter: "url(#filter0_d_38_559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.911 18.563c0 0.0536-3.5725 0.0486-7.9766-0.0112-4.404-0.0597-7.9765-0.1518-7.9753-0.2053 0.0013-0.0536 3.5713-0.0486 7.9778 0.0112 4.4065 0.0597 7.9741 0.1518 7.9741 0.2053z",
    filter: "url(#filter0_d_38_559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.671 26.133c0 0.0535-3.5725 0.0485-7.9765-0.0112-4.4041-0.0598-7.9753-0.1519-7.9753-0.2054s3.5725-0.0486 7.9777 0.0112c4.4053 0.0597 7.9753 0.1518 7.9741 0.2054z",
    filter: "url(#filter0_d_38_559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.626 28.798c0 0.0535-3.5725 0.0485-7.9765-0.0112-4.4041-0.0598-7.9766-0.1531-7.9753-0.2066 0.0012-0.0536 3.5712-0.0486 7.9777 0.0112 4.4066 0.0597 7.9741 0.1531 7.9741 0.2066z",
    filter: "url(#filter0_d_38_559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.578 31.462c0 0.0535-3.5725 0.0486-7.9778-0.0112-4.4053-0.0597-7.9753-0.1518-7.9741-0.2054 0.0013-0.0535 3.5713-0.0485 7.9778 0.0112 4.4065 0.0598 7.9741 0.1519 7.9741 0.2054z",
    filter: "url(#filter0_d_38_559)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.15,0,0,1.15,-4.1064,-2.005)",
    stroke: "#e51c27"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.407,
    cy: 27.309,
    r: 8.5,
    fill: "#fff",
    filter: "url(#filter0_d_38_559)"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.305 22.109-4.105 4.345c-0.155 0.165-0.305 0.49-0.335 0.715l-0.185 1.62c-0.065 0.585 0.355 0.985 0.935 0.885l1.61-0.275c0.225-0.04 0.54-0.205 0.695-0.375l4.105-4.345c0.71-0.75 1.03-1.605-0.075-2.65-1.1-1.035-1.935-0.67-2.645 0.08z",
    filter: "url(#filter0_d_38_559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.62 22.834c0.215 1.38 1.335 2.435 2.725 2.575",
    filter: "url(#filter0_d_38_559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.175 31.309h9",
    filter: "url(#filter0_d_38_559)"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m18.313 14.641c-0.88547 0-1.6059-0.72045-1.6059-1.6059 0-0.88559 0.72045-1.6059 1.6059-1.6059 0.88547 0 1.6059 0.72034 1.6059 1.6059 0 0.88547-0.72045 1.6059-1.6059 1.6059z",
    fill: "#e30917",
    strokeWidth: 1.15
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m18.313 9.895c-2.1925 0-3.9761 1.7837-3.9761 3.9761 0 2.1925 1.7836 3.9761 3.9761 3.9761 2.1924 0 3.9761-1.7836 3.9761-3.9761 0-2.1924-1.7837-3.9761-3.9761-3.9761zm2.6349 6.1936c-0.31302-0.46412-0.74725-0.84545-1.251-1.0897-0.19986-0.09683-0.43308-0.09545-0.64041 0.0041-0.23298 0.11201-0.48322 0.1687-0.74345 0.1687-0.26024 0-0.51035-0.05681-0.74357-0.1687-0.20699-0.09947-0.44044-0.10097-0.6403-0.0041-0.50391 0.24425-0.93802 0.62558-1.2512 1.0897-0.50552-0.59982-0.81095-1.3734-0.81095-2.2175 0-1.9001 1.5458-3.446 3.446-3.446 1.9001 0 3.446 1.5459 3.446 3.446 0 0.84407-0.30554 1.6177-0.81107 2.2175z",
    fill: "#e30917",
    strokeWidth: 1.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_38_559",
    x: 1.5929,
    y: 5.3093,
    width: 47.814,
    height: 46.382,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9890134
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_38_559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_38_559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_38_559",
    x: 0.70967,
    y: 0.033279,
    width: 43.963,
    height: 51.241,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.07443
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.09304
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_38_559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_38_559",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateprofile);
export default __webpack_public_path__ + "static/media/updateprofile.d49fcee1ffa6c8a414644ac0017fffea.svg";
export { ForwardRef as ReactComponent };